import { DateTime } from 'luxon';

export const DATE_NOW = DateTime.now()
  .setZone('UTC')
  .startOf('month');
